import { isoDate } from "@/lib/utils";
import type { CalendarEditableAppointment } from "@/types/appointments/appointment-form-types";
import type { AddAppointmentFormValues } from "@/zod-schemas/appointments/add-appointment-schema";
import type { EditAppointmentFormValues } from "@/zod-schemas/appointments/edit-appointment-schema";

export const EMPTY_APPOINTMENT_SERVICE_LINE: AddAppointmentFormValues["services"][number] =
  {
    staff_id: 0,
    service_id: 0,
    start_time: "",
    duration_minutes: 0,
    price: 0,
  };

export const getAppointmentFormValues = (slot: {
  appointment_date: Date;
  staff_id: number;
  start_time: string;
}): AddAppointmentFormValues => ({
  client_id: 0,
  appointment_date: slot.appointment_date,
  status: "booked",
  services: [
    {
      ...EMPTY_APPOINTMENT_SERVICE_LINE,
      staff_id: slot.staff_id,
      start_time: slot.start_time,
    },
  ],
});

export const getEditAppointmentFormValues = (
  appointment: CalendarEditableAppointment
): EditAppointmentFormValues => ({
  client_id: appointment.client_id,
  appointment_date: isoDate(appointment.appointment_date),
  status: appointment.status,
  services:
    appointment.services.length === 0
      ? [{ ...EMPTY_APPOINTMENT_SERVICE_LINE }]
      : appointment.services.map((line) => ({
          staff_id: line.staff_id,
          service_id: line.service_id,
          start_time: line.start_time,
          duration_minutes: line.duration_minutes,
          price: line.price,
        })),
});
